// Field limits shared by client validation, server validation and database CHECKs (docs/03-domain-rules.md).
export const LIMITS = {
  name: 200,
  title: 200,
  email: 254,
  actionDescription: 2000,
  taskDescription: 2000,
  longDescription: 5000,
  reason: 5000,
  // 8 (BLD-20): the instructor found 12 too long; 8 is the NIST SP 800-63B floor for chosen passwords.
  passwordMin: 8,
  passwordMax: 128,
  collection: 500,
} as const;

export const PLAN_TIMEZONE = "America/Fortaleza";
